<template>
    <div>
        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
                <strong style="font-size: 25px">Objektif</strong>
            </a-col>
            <a-col flex="0 1 300px">
                
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            Cabang:
            <a-select @change="handleChange" style="width: 140px" >
                <a-select-option
                    v-for="d in branches"
                    :key="d.hash"
                    :value="d.hash"
                >
                    {{ d.name }}
                </a-select-option>
            </a-select>
            Divisi: 
            <a-select @change="handleChangeDivision" style="width: 400px" >
                <a-select-option
                    v-for="d in divisions"
                    :key="d.id"
                    :value="d.id"
                >
                    {{ d.name }}
                </a-select-option>
            </a-select>
            <a-button
                type="primary"
                html-type="submit"
                :loading="loading"
                :disabled="loading"
                @click="getItems"
                >View</a-button>

            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.data"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="module" slot-scope="record" class="text-small text-left">
                    {{ record.name }}
                </div>

                <div slot="code" slot-scope="record" class="text-small text-left">
                    {{ record.position_code }}
                </div>

                <div slot="indicator" slot-scope="record" class="text-small text-left">
                    <a-tooltip title="Indicator">
                            <a-button size="small" icon="eye" @click="indicator(record.hash)" />
                    </a-tooltip>
                </div>

                <div slot="updated_at" slot-scope="record" class="text-small text-center">
                    <template v-if="record.updated_at != null">
                        {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-space>
                        <a-tooltip title="Detail">
                            <a-button size="small" icon="eye" :href="routeUri('admin.setting.branch') + '?id=' + record.hash" />
                        </a-tooltip>

                        <a-tooltip title="Edit">
                            <a-button size="small" type="primary" icon="edit" @click="showModal(record.hash)" />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

    </div>
</template>

<script>

const columns = [
    {
		key: 'module',
		title: 'Posisi',
        align: 'center',
		scopedSlots: {customRender: 'module'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'code'},
	}, {
		key: 'indicator',
		title: 'Indicator',
        align: 'center',
        width: '100px',
		scopedSlots: {customRender: 'indicator'},
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        width: '180px',
        scopedSlots: {customRender: 'updated_at'}
    }, 
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                module: 'performance',
            },
            hash: null,
            visible: false,
            branches: [],
            divisions: []
        }
    },
    created() {
        //this.getItems()
        this.getBranches()
        this.getDivisions()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.bank-position'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.positions)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        getDivisions() {
            let params = {
                no_paging: true
            }

            this.$http
                .get(this.routeUri("api.bank-division") + '?' + this.$qs.stringify(params))
                .then(response => this.divisions = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        getBranches() {
            let params = {
                no_paging: true
            }

            this.$http
                .get(this.routeUri("api.branches") + '?' + this.$qs.stringify(params))
                .then(response => this.branches = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.preload = false))
        },
        showModal(hash) {
            this.hash = hash;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        handleChange(value) {
            this.filters.branch = value
        },
        handleChangeDivision(value) {
            this.filters.division = value
        },
        indicator(hash){
            
        }
    },
}
</script>
